import React from "react";
import { Menu, MenuButton, MenuDivider, MenuItem } from "@szhsin/react-menu";

export const UsersSettingsMenu = ({ onMenuItemClick }) => {
  return (
    <Menu
      menuButton={
        <MenuButton>
          <span className="glyphicon glyphicon-cog" />
        </MenuButton>
      }
      overflow="auto"
      onItemClick={(eventObj) => onMenuItemClick(eventObj)}
      direction="right"
      align="start"
      transition
    >
      <MenuItem value="addUser">
        <span>Add New User</span>
      </MenuItem>

      <MenuItem value="addAdminUser">
        <span>Add Admin User</span>
      </MenuItem>

      <MenuItem value="bulkUsersCreation">
        <span>Bulk Users Creation</span>
      </MenuItem>
      <MenuDivider />

      <MenuItem value="exportActiveUsers">
        <span>Export Active Users</span>
      </MenuItem>
    </Menu>
  );
};
